if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

$(document).ready(function(){
  $(document).on('click', 'a.block__mainproduct-comparetxt[href^="#"]', function (event) {
    event.preventDefault();
    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 200
    }, 1000);
  });

  $('.block__mainproduct-earnloyaltylink').click(function(){
    localStorage.setItem('account_current_tab', 'loyalty');
  });


  $('.main-product-optionalcontentwrap input[name="options_metafield"]').click(function(){ 
    var current_val = $(this).val(),
    current_val_title = $(this).attr('data-optionproductname'),
    current_val_price = $(this).attr('data-optionproductprice'),
    current_val_id = $(this).attr('data-optionproductid'),
    current_val_handle = $(this).attr('data-optionproducthandle'),
    current_val_img = $(this).attr('data-optionproductimg'),
    current_val_varianttitle = $(this).attr('data-optionproductvarianttitle'),
    current_val_url = $(this).attr('data-optionproducturl'),
    current_val_qty = $(this).attr('data-optionproductcurrentQty'),
    current_val_mainproduct = $(this).attr('data-optionmainproduct');
    let current_parent = $(this).parents('.product__info-wrapper').find(".product-form form input.productcontent");
    if($(this).prop('checked')){
      $(`<input type="hidden" name="properties[Optional]" value="${current_val_title} +${current_val_price}" data-mainproductname="${current_val_mainproduct}"
      class="product-option-id" data-optionname="${current_val_title}" data-optionprice="${current_val_price}"
      data-optionid="${current_val_id}" data-optionhandle="${current_val_handle}" data-optionimg="${current_val_img}" data-optionvarianttitle="${current_val_varianttitle}" data-optionurl="${current_val_url}" data-optioncurrentqty="${current_val_qty}"></input>`).insertAfter(current_parent);
    }else{
      $(this).parents('.product__info-wrapper').find(".product-form form").find('input.product-option-id[data-optionid="'+current_val_id+'"]').remove();
    }

    if($('.mainproduct-variant .product-form__input input').length > 0){
      var variant_price = parseInt($('.mainproduct-variant .product-form__input input:checked + .productform-variant-label .productform-variant-labelvalprice').attr('data-variantprice'));
    }else{
      var variant_price = parseInt($('.main-product-optional-content').attr('data-mainproductprice'));
    }
      var option_price = 0;
    $('.main-product-optionalcontentwrap input[name="options_metafield"]:checked').each(function(){
      var current_optprice = parseInt($(this).attr('data-optionpricenormal'));
      option_price = parseInt(option_price + current_optprice);
    });
    var final_price = parseInt(option_price + variant_price);
    let product_change_price = (final_price / 100) * 100;
    $('.product__info-wrapper .price__container .product-price-update').text(Shopify.formatMoney(product_change_price, Shopify.money_format));
    var percentage = final_price * 0.02;
    var formattedCurrency = currency_symbol + (percentage / 100).toFixed(2);
    $('.loyalty-percentage').text(formattedCurrency);
    let optionalcount = $('.main-product-optionalcontentwrap input[name="options_metafield"]:checked').length;
    const productinfoClassavilable = document.querySelector('.main-product-section product-info');
    if(!productinfoClassavilable.classList.contains('productcondition-new')){
      if(optionalcount == 0){
        $('.product-form form .product-form__submit').attr('disabled',true);
      }else{
        $('.product-form form .product-form__submit').removeAttr('disabled');
      }
    }else{}
    

  });

  const elementsoptional = document.querySelectorAll('.main-product-optionalcontentwrap input[name="options_metafield"]');
  if (elementsoptional.length > 0) {
    const productinfoClass = document.querySelector('.main-product-section product-info');
    if(!productinfoClass.classList.contains('productcondition-new')){
      elementsoptional[0].click();
    }else{}
  } 

  // upsell products option js

  const upsellproducts = document.querySelectorAll('.product-upsell-slider')
    upsellproducts && upsellproducts.forEach(upsellproductslist => {
        new Swiper(upsellproductslist, {
            slidesPerView: 3,
            spaceBetween: 20,
            loop: false,
            navigation: {
                nextEl: '.upsell-next',
                prevEl: '.upsell-prev',
            },
            breakpoints: {
                200: {
                    slidesPerView: 1
                },
                370: {
                    slidesPerView: 2
                },
                750: {
                    slidesPerView: 3
                },
                1200: {
                    slidesPerView: 3
                }
            }
        });
    });

}) 